import firebase from "../firebase";
import GENRALHELPERS from "../GENRAL-HELPERS";
import spinner from "../spinner";

import generateHtmlListings from "../display-listing/generate-html";
import ownListings from "../own-listing-actions/own-listings";




const deleteAccountDeleteAllWindowButtonDeleteAccount = document.getElementById("deleteAccountDeleteAllWindowButtonDeleteAccount");
const deleteAccountDeleteAllWindowButtonDeleteAll = document.getElementById("deleteAccountDeleteAllWindowButtonDeleteAll");
const deleteAccountDeleteAllItemsCon = document.getElementById("deleteAccountDeleteAllItemsCon");
const deleteAccountDeleteAllWindow = document.getElementById("deleteAccountDeleteAllWindow");
const deleteAccountDeleteAllWindowButtonClose = document.getElementById("deleteAccountDeleteAllWindowButtonClose");



const SingUpWindow = document.getElementById("SingUpWindow");
const SingUpWindowButtonClose = document.getElementById("SingUpWindowButtonClose");
const SingUpWindowButtonSelectSignUp = document.getElementById("SingUpWindowButtonSelectSignUp");
const createAccountTermsPrivacyPolicyTextForLink = document.getElementById("createAccountTermsPrivacyPolicyTextForLink");
const SingUpWindowButtonSelectSignIn = document.getElementById("SingUpWindowButtonSelectSignIn");

const SingUpInputEmail = document.getElementById("SingUpInputEmail");
const SingUpInputPassword = document.getElementById("SingUpInputPassword");
const SingUpInputPasswordConfirm = document.getElementById("SingUpInputPasswordConfirm");
const SingInInputEmail = document.getElementById("SingInInputEmail");
const SingInInputPassword = document.getElementById("SingInInputPassword");

const SignUpWindowPartSignUp = document.getElementById("SignUpWindowPartSignUp");
const SignUpWindowPartConfirmEmail = document.getElementById("SignUpWindowPartConfirmEmail");
const SignUpWindowPartSingIn = document.getElementById("SignUpWindowPartSingIn");

const SignUpWindowPartParrentSignUpSignIn = document.getElementById("SignUpWindowPartParrentSignUpSignIn");
const SignUpWindowPartParrentProfileAccount = document.getElementById("SignUpWindowPartParrentProfileAccount");

const SignUpWindowProfileAccountEmailVerifyAlert = document.getElementById("SignUpWindowProfileAccountEmailVerifyAlert");
const SignUpWindowProfileAccountEmailVerifyAlertButtonVerify = document.getElementById("SignUpWindowProfileAccountEmailVerifyAlertButtonVerify");

const SignUpWindowProfileAccountAccount = document.getElementById("SignUpWindowProfileAccountAccount");
const SignUpWindowProfileAccountProfileAlert = document.getElementById("SignUpWindowProfileAccountProfileAlert");
const SignUpWindowProfileAccountProfile = document.getElementById("SignUpWindowProfileAccountProfile");

const SignUpWindowButtonSignUp = document.getElementById("SignUpWindowButtonSignUp");
const SignUpWindowButtonConfirmEmailConfirmEmail = document.getElementById("SignUpWindowButtonConfirmEmailConfirmEmail");
const SignUpWindowButtonConfirmEmailResendCode = document.getElementById("SignUpWindowButtonConfirmEmailResendCode");
const SignUpWindowButtonConfirmEmailChangeEmail = document.getElementById("SignUpWindowButtonConfirmEmailChangeEmail");
const SignUpWindowButtonSignIn = document.getElementById("SignUpWindowButtonSignIn");
const SignUpWindowButtonForgotPassword = document.getElementById("SignUpWindowButtonForgotPassword");
const SignUpWindowButtonChangePassword = document.getElementById("SignUpWindowButtonChangePassword");

const SignUpWindowProfileAccountButtonSignOut = document.getElementById("SignUpWindowProfileAccountButtonSignOut");
const SignUpWindowProfileAccountButtonDeleteAccount = document.getElementById("SignUpWindowProfileAccountButtonDeleteAccount");

const SignUpWindowProfileAccountDisplayEmail = document.getElementById("SignUpWindowProfileAccountDisplayEmail");

const ProfileInputName = document.getElementById("ProfileInputName");
const ProfileInputWhatsAppNumber = document.getElementById("ProfileInputWhatsAppNumber");
const ProfileSelectWhatsAppNumberContryCode = document.getElementById("ProfileSelectWhatsAppNumberContryCode");
const ProfileInputMobileNumber = document.getElementById("ProfileInputMobileNumber");
const ProfileSelectCallNumberContryCode = document.getElementById("ProfileSelectCallNumberContryCode");
const ProfileImgContainer = document.getElementById("ProfileImgContainer");

const ProfileButtonSaveProfile = document.getElementById("ProfileButtonSaveProfile");




class signUpProfile {


    #changedProfileImg = false;
    #changesToBeSaved = false;
    #sellerProfile = {
        userName: "",
        callNumber: "",
        whatsAppNumber: "",
        profileImageUrl: "",
        sellerProfileStatus: "active",
        sellerProfileTokens: [],
    }


    #loadedBusinessesForDeletion = []
    #loadedListingsForDeletion = []



    #openEmailVerificationEventInitialized = false;
    #emailVerificationResendInterval = null

    #profileImageChanged = false

    constructor() {
        console.log("signUpProfile module loaded");
        this._events();

        this._togglePassword('SingUpInputPassword')
        this._togglePassword('SingUpInputPasswordConfirm')
        this._togglePassword('SingInInputPassword')
        // this._displaySignUpWindow("profileAccount");
        // this._displaySignUpWindow("completeProfile");
        // this._displaySignUpWindow("signUp");
    }

    async _saveSellerProfile(close) {
        let valid = true;

        const name = ProfileInputName.value.trim()
        const whatsAppNumber = ProfileInputWhatsAppNumber.value.trim()
        const whatsAppNumberCountryCode = ProfileSelectWhatsAppNumberContryCode.value
        const callNumber = ProfileInputMobileNumber.value.trim()
        const callNumberCountryCode = ProfileSelectCallNumberContryCode.value


        try {
            if (name?.length < 2) {
                throw new Error('El nombre no es un nombre válido. Tiene que tener por lo menos 3 caráteres.')
            }
            if (callNumber?.length < 2) {
                throw new Error('El número de Llamandas no es un número válido.')
            }
            if (whatsAppNumber?.length < 2) {
                throw new Error('El número de WhatsApp no es un número válido.')
            }



            spinner._displaySpinner("Subiendo imagen de perfil");



            const imgs = await firebase._uploadImagesAndGetReferences(
                "ProfileImgContainerA", 'imageProgressCon', null, 'public/tempUploads/'
            );

            const accountData = {
                userName: name,
                whatsAppNumber: whatsAppNumber,
                whatsAppNumberCountryCode: whatsAppNumberCountryCode,
                callNumber: callNumber,
                callNumberCountryCode: callNumberCountryCode,
                profileImages: imgs,
                about: 'Vendedor en Mercado MAI',
                profileImageChanged: this.#profileImageChanged
            }

            console.log(accountData);

            // spinner._hideSpinner()
            // return

            // const profileImgUrl = await firebase._uploadImagesByUrls(
            //     [ProfileImgContainer.src]
            // );
            // accountData.profileImageUrl = profileImgUrl[0];

            spinner._displaySpinner("Subiendo perfil de vendedor");

            accountData.sellerProfileTokens = GENRALHELPERS._generateTokens(
                [name, whatsAppNumber, callNumber],
                ["&", "de", "y", "para"]
            );



            const updateProfileResult = await firebase._updateUserTemplate(
                accountData
            );
            console.log(updateProfileResult);
            if (updateProfileResult.data.status === "error") {
                throw new Error(
                    `Hubo un error en actualizar tu perfil de vendedor. ${updateProfileResult.data.message}`
                );
            }
            if (updateProfileResult.data.status === "success") {
                ProfileOpenSellerProfileSaveButton.style.display = "none";
                ProfileOpenSellerProfileSaveButton.classList.remove(
                    "ProfileOpenSellerProfileSaveButtonNoneAct"
                );
                this.#changesToBeSaved = false;
                if (close) {
                    this._close();
                }
                alert("Éxito. ¡Perfil de vendedor actualizado correctamente!");
            }
        } catch (error) {
            alert(error.message)
            console.error(error);
        } finally {
            spinner._hideSpinner()
        }
    }
    _checkIfReady = (what) => {
        this.#changesToBeSaved = true;
        let allValid = true; // Tracks overall validity
        const checkImg = () => {
            const messageCon = profileImage
                .closest(".ProfileOpenFotoCon")
                .querySelector(".ProfileOpenInputMessage");

            // Check if the profile image is the placeholder or empty
            if (
                profileImage.src.includes("profile-img-placeholder") ||
                profileImage.src === ""
            ) {
                console.warn("this was true somehow");
                console.log(profileImage.src.includes("profile-img-placeholder"));
                console.log(profileImage.src);
                messageCon.classList.add("ProfileOpenInputMessageError");
                messageCon.classList.remove("ProfileOpenInputMessageSuccess");
                messageCon.textContent = "Una foto de perfil es requerida"; // Grammar correction
                return false;
            } else {
                messageCon.classList.remove("ProfileOpenInputMessageError");
                messageCon.classList.add("ProfileOpenInputMessageSuccess");
                messageCon.textContent = ""; // Provide positive feedback
                return true;
            }
        };

        const checkName = () => {
            const messageCon = ProfileOpenInputSellerName.closest(
                ".ProfileOpenInputCon2"
            ).querySelector(".ProfileOpenInputMessage");

            if (
                !this.#sellerProfile.userName ||
                this.#sellerProfile.userName.length < 3
            ) {
                if (what === "name") {
                    messageCon.classList.add("ProfileOpenInputMessageError");
                    messageCon.classList.remove("ProfileOpenInputMessageSuccess");
                    messageCon.textContent = !this.#sellerProfile.userName
                        ? "El nombre de vendedor es requerido"
                        : "El nombre de vendedor no puede ser menor a 3 carácteres";
                }
                return false;
            }
            if (what === "name") {
                messageCon.classList.remove("ProfileOpenInputMessageError");
                messageCon.classList.add("ProfileOpenInputMessageSuccess");
                messageCon.textContent = "Nombre válido";
            }
            return true;
        };

        const checkCallNumber = () => {
            const messageCon = ProfileOpenInputPhoneNumber.closest(
                ".ProfileOpenInputCon2"
            ).querySelector(".ProfileOpenInputMessage");

            if (
                !this.#sellerProfile.callNumber ||
                this.#sellerProfile.callNumber.length !== 10
            ) {
                if (what === "callNumber") {
                    messageCon.classList.add("ProfileOpenInputMessageError");
                    messageCon.classList.remove("ProfileOpenInputMessageSuccess");
                    messageCon.textContent = !this.#sellerProfile.callNumber
                        ? "Número de llamadas es requerido"
                        : "Número de llamadas no válido";
                }
                return false;
            }
            if (what === "callNumber") {
                messageCon.classList.remove("ProfileOpenInputMessageError");
                messageCon.classList.add("ProfileOpenInputMessageSuccess");
                messageCon.textContent = "Número válido";
            }
            return true;
        };

        const checkWhatsAppNumber = () => {
            const messageCon = ProfileOpenInputWhatsAppNumber.closest(
                ".ProfileOpenInputCon2"
            ).querySelector(".ProfileOpenInputMessage");

            if (
                !this.#sellerProfile.whatsAppNumber ||
                this.#sellerProfile.whatsAppNumber.length !== 10
            ) {
                if (what === "whatsAppNumber") {
                    messageCon.classList.add("ProfileOpenInputMessageError");
                    messageCon.classList.remove("ProfileOpenInputMessageSuccess");
                    messageCon.textContent = !this.#sellerProfile.whatsAppNumber
                        ? "Número de WhatsApp es requerido"
                        : "Número de WhatsApp no válido";
                }
                return false;
            }
            if (what === "whatsAppNumber") {
                messageCon.classList.remove("ProfileOpenInputMessageError");
                messageCon.classList.add("ProfileOpenInputMessageSuccess");
                messageCon.textContent = "Número válido";
            }
            return true;
        };

        // Perform all checks and track validity
        allValid = checkImg() && allValid;
        allValid = checkName() && allValid;
        allValid = checkCallNumber() && allValid;
        allValid = checkWhatsAppNumber() && allValid;

        // Toggle save button based on overall validity
        if (allValid) {
            ProfileOpenSellerProfileSaveButton.classList.remove(
                "ProfileOpenSellerProfileSaveButtonNoneAct"
            );
            return allValid;
        } else {
            ProfileOpenSellerProfileSaveButton.classList.add(
                "ProfileOpenSellerProfileSaveButtonNoneAct"
            );
            return allValid;
        }
    };

    _open(completeProfile) {
        try {

            const decide = () => {

                const accountdata = firebase._getLatestCurrentUserData()
                console.log(accountdata);

                if (!accountdata) {
                    this._displaySignUpWindow("signUp");
                    this._select('signIn')
                    return
                }
                if (!accountdata.userName && completeProfile) {
                    this._displaySignUpWindow("completeProfile");
                } else {
                    this._displaySignUpWindow("profileAccount");
                }
                if (accountdata.userName) {
                    this._displaySignUpWindow("profileAccount");
                }
            }
            decide();

            SingUpWindow.style.display = "flex";
        } catch (error) {

        }
    }
    _close() {
        SingUpWindow.style.display = "none";
    }




    async _deleteAllNow() {
        try {
            spinner._displaySpinner('Procesando...', 10000);

            const itemsCon = document.getElementById('deleteAccountDeleteAllItemsCon');
            console.log(itemsCon);

            const confirmDelete = confirm(
                '¡ADVERTENCIA!\n¿Estás seguro que quieres eliminar todas tus publicaciones? Esta acción es irreversible.'
            );

            if (!confirmDelete) {
                console.log('Canceled');
                return false;
            }

            spinner._displaySpinner('Eliminando...', 20000);

            await Promise.all([
                ...this.#loadedBusinessesForDeletion.map(async (bus) => {
                    console.log(bus);
                    const delRes = await firebase._NVDeleteBusiness({
                        businessId: bus.businessId
                    });

                    if (delRes.data.status === 'success') {
                        // if ('success' === 'success') {

                        const items = itemsCon.querySelectorAll('.v20BusinessCon1A')
                        items.forEach(el => {
                            console.log(el);
                            const lisId = el.dataset.listignid
                            // console.log('li.listingId:', li.listingId, 'lisId:', lisId);
                            if (el.dataset.listingid === bus.listingId) {
                                console.log(el);
                                el?.closest('.v20BusinessCon1A')?.remove();
                            }
                        })
                    }



                    // return delRes;
                }),

                ...this.#loadedListingsForDeletion.map(async (li) => {
                    const delRes = await firebase._NVDeleteListing({
                        lives: 'seller',
                        parentId: li.sellerId,
                        listingId: li.listingId
                    });

                    // This was `deleteResult`, but that variable does not exist.
                    if (delRes.data.status === 'success') {
                        // if ('success' === 'success') {
                        console.log(itemsCon);
                        console.log('here now');
                        const items = itemsCon.querySelectorAll('.nvListingVerCon1')
                        items.forEach(el => {
                            console.log(el);
                            const lisId = el.dataset.listignid
                            console.log('li.listingId:', li.listingId, 'lisId:', lisId);
                            if (el.dataset.listingid === li.listingId) {
                                console.log(el);
                                el?.closest('.nvListingVerCon1A')?.remove();
                            }
                        })

                        console.log(items);
                    }

                    return delRes;
                })
            ]);

            return true;
        } catch (error) {
            console.error('Could not delete all items:', error);
            throw error; // lets the caller react to failure
        } finally {
            spinner._hideSpinner();
        }
    }

    async _deleteAccountNow() {
        try {
            const confirmDelete = confirm('¡ADVERTENCIA!\n ¿Estás seguro que quieres eliminar tu cuenta? Esta acción es ireversible.')

            if (confirmDelete) {
                console.log('Deleting account now.');

                spinner._displaySpinner('Eliminando tu cuenta. Esto puede tardar un poco.', 20000)

                const { data } = await firebase._deleteAccount({ accountId: 'currentAccount' })
                console.log(data);

                if (data.success) {
                    window.location.reload();
                } else {
                    alert(data.message)
                }


            } else {
                console.log('Canceled');
            }
        } catch (error) {

        } finally {
            spinner._hideSpinner()
        }

    }

    async _openDeleteAll() {
        console.log('here');

        let showDelete = false
        try {

            const parent1 = document.getElementById('deleteAccountDeleteAllWindowButtonDeleteAccounParent')
            const parent2 = document.getElementById('deleteAccountDeleteAllWindowButtonDeleteAllParent')


            //
            parent1.style.display = 'none'
            parent2.style.display = 'none'

            this.#loadedBusinessesForDeletion = []
            this.#loadedListingsForDeletion = []
            deleteAccountDeleteAllItemsCon.innerHTML = ''
            console.log('here');

            deleteAccountDeleteAllWindow.style.display = "flex";
            console.log('here');

            const account = firebase._getLatestCurrentUserData()

            // await firebase._getUserDataFromBase(userData.userId)
            // const account = firebase._getLatestCurrentUserData()
            console.log(account);

            if (account?.businesses?.length > 0) {
                console.log('here');
                for (const bus of account.businesses) {
                    console.log('here');

                    if (bus.role === 'owner') {
                        console.log('here');
                        console.log(`businesses/${bus.id}`);
                        const loadedBusiness = await firebase._getAnyDocById(`businesses/${bus.id}`)
                        console.log(loadedBusiness);


                        if (!loadedBusiness) {
                            console.log('here');
                            alert(`Este negocio ya no existe.`);
                            continue; // 👈 skip this business and move on
                        }
                        console.log('here');

                        this.#loadedBusinessesForDeletion.push(loadedBusiness)
                        console.log('here');

                        const { listings, lastVisibleDoc } =
                            await firebase._getRecentListingsWithFilter(
                                null,
                                3,
                                `businesses/${bus.id}/listings`
                            );
                        console.log('here');

                        let listingsHtml = ``;
                        console.log('here');
                        if (!listings || listings.length === 0) {
                            console.log('here');
                            listingsHtml +=
                                generateHtmlListings._listingVerticalMiniNoListings();
                        } else {
                            console.log('here');
                            for (const listing of listings) {
                                console.log('here');
                                listingsHtml +=
                                    await generateHtmlListings._listingVerticalMini(
                                        listing,
                                        null,
                                        "listingInBusiness",
                                        bus.id
                                    );
                                console.log('listingsHtml', listingsHtml);
                            }
                            console.log('here');
                        }
                        console.log('here');
                        const businessInPackHtml =
                            await generateHtmlListings._generateBusiness2v(
                                listingsHtml,
                                loadedBusiness, null, null, true, false
                            );
                        console.log('here');
                        deleteAccountDeleteAllItemsCon.insertAdjacentHTML("beforeend", businessInPackHtml);
                        console.log('here');
                        showDelete = true

                        console.log('here');
                    }
                }
            }

            const loadedListings = await firebase._getAllDocsFromPathByMostRecent(`accounts/${account.userId}/listings`, true)
            console.log(loadedListings)
            if (!loadedListings) {
                throw new Error("No hemos podido cargar tus listados en este momento. Intenta de nuevo mas tarde.")
            }

            this.#loadedListingsForDeletion = loadedListings

            if (loadedListings.length > 0) {

                loadedListings.forEach((listing) => {
                    const listingHtml = generateHtmlListings._listingVerticalNV(listing, true, 'listing', false, true)
                    deleteAccountDeleteAllItemsCon.insertAdjacentHTML("beforeend", listingHtml);
                    showDelete = true
                })
            }


            console.log(account);
            console.log(showDelete);


            if (!showDelete) {
                parent2.style.display = 'none'
                parent1.style.display = 'flex'
            } else {
                parent2.style.display = 'flex'
                parent1.style.display = 'none'
            }


        } catch (error) {

        }
    }
    _closeDeleteAll() {
        deleteAccountDeleteAllWindow.style.display = "none";
    }

    async _signOut() {
        const confirmLogOut = confirm(
            `¿Estás seguro que quieres cerar sesión con esta cuenta?
                Tus datos no se borarán.
                Los podras acceder al iniciar sesión con esta cuenta otra vez.`
        );
        console.log(confirmLogOut);

        if (!confirmLogOut) return;

        await firebase._signOutUser();
    }

    async _signUp() {
        console.log("process");

        try {

            const signUpData = {
                email: SingUpInputEmail.value.trim().toLowerCase(),
                password: SingUpInputPassword.value.trim(),
                passwordConfirm: SingUpInputPasswordConfirm.value.trim(),
            };

            const termsCheckbox = document.getElementById(
                "createAccountTermsPrivacyPolicyCheckbox"
            );

            // Check for empty fields
            if (
                !signUpData.email ||
                !signUpData.password ||
                !signUpData.passwordConfirm
            ) {
                throw new Error("Por favor, completa todos los campos.");
            }

            // Check if email format is valid
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

            if (!emailRegex.test(signUpData.email)) {
                throw new Error("Por favor, ingresa un correo válido.");
            }

            // Check password strength
            // Minimum 6 characters, at least one letter and one number
            const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d).{6,}$/;

            if (!passwordRegex.test(signUpData.password)) {
                throw new Error(
                    "La contraseña debe tener al menos 6 caracteres y contener una letra y un número."
                );
            }

            // Check if passwords match
            if (signUpData.password !== signUpData.passwordConfirm) {
                throw new Error("Las contraseñas no coinciden.");
            }

            // Check terms checkbox
            if (!termsCheckbox.checked) {
                throw new Error(
                    "Debes aceptar los términos y la política de privacidad."
                );
            }

            // Continue signup process...
            console.log(signUpData);

            const signUpResult = await firebase._authenticateNewUser(signUpData.email, signUpData.password)
            if (signUpResult.success) {
                this._close()
                this._openEmailVerification(null, true);
            } else {

                console.error(signUpResult);

                switch (signUpResult.errorCode) {

                    case "auth/email-already-in-use":

                        alert(
                            "Ya existe una cuenta con este correo electrónico. Por favor inicia sesión."
                        );

                        break;

                    case "auth/invalid-email":

                        alert(
                            "El correo electrónico no es válido."
                        );

                        break;

                    case "auth/weak-password":

                        alert(
                            "La contraseña es demasiado débil."
                        );

                        break;

                    case "auth/network-request-failed":

                        alert(
                            "Error de conexión. Verifica tu internet e inténtalo nuevamente."
                        );

                        break;

                    case "auth/too-many-requests":

                        alert(
                            "Demasiados intentos. Inténtalo nuevamente más tarde."
                        );

                        break;

                    default:

                        alert(
                            "Ocurrió un error al crear la cuenta. Inténtalo nuevamente."
                        );

                        break;

                }
            }

        } catch (error) {
            console.error(error);
            alert(error.message);
        }
    }

    async _signIn() {
        console.log("process");

        // this._addInputFocusListenersToRemoveMessage();

        // Check for empty fields
        if (!SingInInputEmail.value.trim() || !SingInInputPassword.value.trim()) {
            alert("Por favor, completa todos los campos.");
            return;
        }
        const logInData = {
            email: SingInInputEmail.value.trim(),
            password: SingInInputPassword.value.trim(),
        };

        try {
            const singInResult = await firebase._signInUser(
                logInData.email,
                logInData.password
            );

            this._close()

            // this._displayAccountInDone("Has iniciado sesión con éxito");
        } catch (error) {
            if (error.message.includes("auth/invalid-credential")) {
                alert(
                    "No podimos encontrar tu cuenta. Asegurate que los dato son los datos corectos. O si aún no tienes una cuenta en Mercado MAI, crea una primero."
                );
            }
        }
    }

    async _displaySignUpWindow(optionIn) {
        const account = firebase._getLatestCurrentUserData()

        const result =
            await firebase._checkEmailVerificationStatus();

        console.log(result);
        console.log(result.verified);
        this.#profileImageChanged = false

        if (!account?.emailVerified) {
            if (account?.emailVerifiedPendingFrom) {
                SignUpWindowProfileAccountEmailVerifyAlert.style.display = "flex";
            } else {
                SignUpWindowProfileAccountEmailVerifyAlert.style.display = "flex";
            }
        } else {
            SignUpWindowProfileAccountEmailVerifyAlert.style.display = "none";
        }

        console.log(optionIn);

        let option = optionIn
        SignUpWindowPartSignUp.style.display = "none";
        SignUpWindowPartConfirmEmail.style.display = "none";
        SignUpWindowPartSingIn.style.display = "none";


        SignUpWindowProfileAccountAccount.style.display = "none";
        SignUpWindowProfileAccountProfileAlert.style.display = "none";
        SignUpWindowProfileAccountProfile.style.display = "none";


        SignUpWindowPartParrentSignUpSignIn.style.display = "none";
        SignUpWindowPartParrentProfileAccount.style.display = "none";


        const accountdata = firebase._getLatestCurrentUserData()
        console.log(accountdata);


        if (option === "signUp") {
            setTimeout(() => {
                SingUpInputEmail.focus();
            }, 1000);
            SignUpWindowPartParrentSignUpSignIn.style.display = "flex";
            SignUpWindowPartSignUp.style.display = "flex";
        }
        if (option === "signIn") {
            setTimeout(() => {
                SingInInputEmail.focus();
            }, 1000);
            SignUpWindowPartParrentSignUpSignIn.style.display = "flex";
            SignUpWindowPartSingIn.style.display = "flex";
        }
        if (option === "confirmEmail") {
            SignUpWindowPartParrentSignUpSignIn.style.display = "flex";
            SignUpWindowPartConfirmEmail.style.display = "flex";
        }
        if (option === "profileAccount") {
            let sellerStatus = true
            let name = accountdata.userName
            let whatsApp = accountdata.whatsAppNumber
            let call = accountdata.callNumber
            let imageUrl = accountdata?.profileImages?.[0]?.res_200 || accountdata?.profileImage || ''

            if (!name) {
                name = ''
                sellerStatus = false
            }
            if (!whatsApp) {
                whatsApp = ''
                sellerStatus = false
            }
            if (!call) {
                call = ''
                sellerStatus = false
            }
            if (!imageUrl) {
                imageUrl = ''
                sellerStatus = false
            }

            if (!sellerStatus) {
                // const proceedToCompleteProfile = confirm(
                //     "Tu perfil de vendedor no está completo. ¿Quieres completar tu perfil ahora?"
                // );
                // if (proceedToCompleteProfile) {
                //     this._displaySignUpWindow("completeProfile");
                //     return
                // } else {
                //     alert("Puedes completar tu perfil de vendedor más tarde desde la configuración de tu cuenta.");
                // }
            }

            SignUpWindowProfileAccountDisplayEmail.textContent = accountdata.email
            ProfileInputName.value = name
            ProfileInputWhatsAppNumber.value = whatsApp
            ProfileInputMobileNumber.value = call
            ProfileImgContainer.src = imageUrl

            SignUpWindowPartParrentProfileAccount.style.display = "flex";
            SignUpWindowProfileAccountAccount.style.display = "flex";
            SignUpWindowProfileAccountProfile.style.display = "flex";
        }
        if (option === "completeProfile") {
            SignUpWindowProfileAccountDisplayEmail.textContent = accountdata.email

            SignUpWindowPartParrentProfileAccount.style.display = "flex";
            SignUpWindowProfileAccountProfile.style.display = "flex";
            SignUpWindowProfileAccountProfileAlert.style.display = "flex";
        }


    }

    _select(option) {
        setTimeout(() => {
            if (option === "signUp") {
                SingUpWindowButtonSelectSignUp.classList.add("nvSignUpOrSignInCon2ACT");
                SingUpWindowButtonSelectSignIn.classList.remove("nvSignUpOrSignInCon2ACT");
                SingUpWindowButtonSelectSignUp.children[0].classList.add("nvSignUpOrSignInText1ACT");
                SingUpWindowButtonSelectSignIn.children[0].classList.remove("nvSignUpOrSignInText1ACT");
                this._displaySignUpWindow("signUp");
            } else if (option === "signIn") {
                SingUpWindowButtonSelectSignIn.classList.add("nvSignUpOrSignInCon2ACT");
                SingUpWindowButtonSelectSignUp.classList.remove("nvSignUpOrSignInCon2ACT");
                SingUpWindowButtonSelectSignIn.children[0].classList.add("nvSignUpOrSignInText1ACT");
                SingUpWindowButtonSelectSignUp.children[0].classList.remove("nvSignUpOrSignInText1ACT");
                this._displaySignUpWindow("signIn");
            }
        }, 200);
    }

    _togglePassword(id) {
        const input = document.getElementById(id);
        if (!input) return;

        const inputParrent = input.parentElement;
        if (!inputParrent) return;

        const eyeIcon = inputParrent.querySelector(".passwordToggleButton");

        eyeIcon.addEventListener("click", () => {
            input.type = input.type === "password" ? "text" : "password";
        })

    }

    async _sendVerificationEmail() {

        const result = await firebase._sendVerificationEmail()
        return result

    }
    async _checkEmailVerificationStatus() {
        spinner._displaySpinner('Procesando verificación')
        const nvEmailVerificationCon5 = document.getElementById("nvEmailVerificationCon5");
        const nvEmailVerificationCon14 = document.getElementById("nvEmailVerificationCon14");


        try {
            const result =
                await firebase._checkEmailVerificationStatus();

            console.log(result);
            console.log(result.verified);

            if (result.verified) {
                // nvEmailVerificationCon5.style.display = "none";
                // nvEmailVerificationCon14.style.display = "flex";
                // console.log("User verified");



                const account = firebase._getLatestCurrentUserData()

                if (!account.emailVerified) {
                    const result = await firebase._updateUserEmailVerifiedStatus()

                    if (result.data.status === 'success') {
                        nvEmailVerificationCon5.style.display = "none";
                        nvEmailVerificationCon14.style.display = "flex";
                        SignUpWindowProfileAccountEmailVerifyAlert.style.display = 'none'
                    } else {
                        nvEmailVerificationCon5.style.display = "flex";
                        nvEmailVerificationCon14.style.display = "none";
                        alert('Tu correo aun no está verificado. Necesitas seguir las instrucciones para verificar tu correo.');
                    }

                } else {
                    nvEmailVerificationCon5.style.display = "none";
                    nvEmailVerificationCon14.style.display = "flex";
                }

                return true
            } else {
                nvEmailVerificationCon5.style.display = "flex";
                nvEmailVerificationCon14.style.display = "none";
                alert('Tu correo aun no está verificado. Necesitas seguir las instrucciones para verificar tu correo.');

                console.log("User NOT verified");


                return false
            }
        } catch (error) {
            console.log(error);
        } finally {
            spinner._hideSpinner()
        }

    }

    async _openEmailVerification(email, fromNewAuth = true) {
        console.log('is here');

        const nvEmailVerificationCon1 = document.getElementById("nvEmailVerificationCon1");
        const nvEmailVerificationButtonBack = document.getElementById("nvEmailVerificationButtonBack");
        const nvEmailVerificationButtonOpenApp = document.getElementById("nvEmailVerificationButtonOpenApp");
        const nvEmailVerificationButtonCompleted = document.getElementById("nvEmailVerificationButtonCompleted");
        const nvEmailVerificationButtonResend = document.getElementById("nvEmailVerificationButtonResend");
        const nvEmailVerificationButtonWhatsApp = document.getElementById("nvEmailVerificationButtonWhatsApp");
        const nvEmailVerificationText1Email = document.getElementById("nvEmailVerificationText1Email");
        const nvEmailVerificationText5Timer = document.getElementById("nvEmailVerificationText5Timer");
        const nvEmailVerificationCon5 = document.getElementById("nvEmailVerificationCon5");
        const nvEmailVerificationCon14 = document.getElementById("nvEmailVerificationCon14");

        try {
            spinner._displaySpinner('Verificación')

            const userAccount = firebase._getLatestCurrentUserData()
            nvEmailVerificationText1Email.textContent = `${userAccount?.email || "tu correo electrónico"}`;

            console.log('is here', userAccount);
            // =========================
            // RESEND TIMER
            // =========================

            const RESEND_SECONDS = 60;

            // clear previous timer if exists
            if (this.#emailVerificationResendInterval) {
                clearInterval(this.#emailVerificationResendInterval);
            }

            const startResendCooldown = () => {

                let secondsLeft = RESEND_SECONDS;

                // disable button
                nvEmailVerificationButtonResend.style.opacity = "0.5";
                nvEmailVerificationButtonResend.style.pointerEvents = "none";

                nvEmailVerificationText5Timer.textContent =
                    `${secondsLeft} segundos`;

                this.#emailVerificationResendInterval = setInterval(() => {

                    secondsLeft--;

                    nvEmailVerificationText5Timer.textContent =
                        `${secondsLeft} segundos`;

                    if (secondsLeft <= 0) {

                        clearInterval(
                            this.#emailVerificationResendInterval
                        );

                        nvEmailVerificationButtonResend.style.opacity = "1";
                        nvEmailVerificationButtonResend.style.pointerEvents = "auto";

                        nvEmailVerificationText5Timer.textContent =
                            "Puedes reenviar el correo";

                    }

                }, 1000);

            };

            const result = this._checkEmailVerificationStatus()

            nvEmailVerificationCon1.style.display = "flex";


            // =========================
            // VERIFIED
            // =========================

            if (result) {
            } else {
                console.log('is here');
                // send email automatically
                // only when NOT coming from fresh signup
                if (!fromNewAuth) {
                    const result = await this._sendVerificationEmail();
                    if (!result.success) {
                        alert('No hemos podido enviar el enlace de verificación en este momento. Intenta de nuevo mas tarde, o ponte en contacto con nuestro equipo de soporte. WhatsApp al 981 107 2143')
                        return
                    }
                }

                nvEmailVerificationCon5.style.display = "flex";
                nvEmailVerificationCon14.style.display = "none";


                console.log(email,);

                // start cooldown immediately
                startResendCooldown();

            }

            // =========================
            // EVENTS
            // =========================
            console.log('is here');
            if (this.#openEmailVerificationEventInitialized) return;

            this.#openEmailVerificationEventInitialized = true;
            console.log('is here');

            nvEmailVerificationButtonBack.addEventListener(
                "click",
                () => {

                    nvEmailVerificationCon1.style.display = "none";

                }
            );

            nvEmailVerificationButtonResend.addEventListener(
                "click",
                async () => {

                    // extra protection
                    if (
                        nvEmailVerificationButtonResend.style.pointerEvents === "none"
                    ) return;

                    await this._sendVerificationEmail();

                    // restart cooldown
                    startResendCooldown();

                }
            );

            nvEmailVerificationButtonCompleted.addEventListener(
                "click",
                async () => {
                    this._checkEmailVerificationStatus();
                }
            );
            nvEmailVerificationButtonOpenApp.addEventListener(
                "click",
                async () => {
                    nvEmailVerificationCon1.style.display = "none";
                }
            );

            nvEmailVerificationButtonWhatsApp.addEventListener(
                "click",
                () => {

                    GENRALHELPERS._openOutboundLink(
                        "https://wa.me/529811072143?text=Necesito%20ayuda%20en%20verificar%20mi%20correo%20electr%C3%B3nico%20en%20Mercado%20MAI"
                    );

                }
            );

            console.log('is here');
        } catch (error) {

            console.log(error);

        } finally {
            console.log('is here');
        }

    }

    async _forgotPassword() {

        let email =
            SingInInputEmail.value.trim().toLowerCase();

        if (!email) {
            const account = firebase._getLatestCurrentUserData()
            email = account?.email || null
        }



        if (!email) {

            alert(
                'Debes ingresar tu correo electrónico en el campo de arriba.'
            );

            return;

        }

        // basic email validation
        const emailRegex =
            /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!emailRegex.test(email)) {

            alert(
                'Debes ingresar un correo electrónico válido.'
            );

            return;

        }

        const result =
            await firebase._sendPasswordResetEmail(email);

        if (result.success) {

            alert(
                `Hemos enviado un enlace a ${email} para restablecer tu contraseña.`
            );

        } else {

            switch (result.errorCode) {

                case "auth/user-not-found":

                    alert(
                        'No encontramos una cuenta con este correo electrónico.'
                    );

                    break;

                case "auth/too-many-requests":

                    alert(
                        'Demasiados intentos. Inténtalo nuevamente más tarde.'
                    );

                    break;

                default:

                    alert(
                        'Ocurrió un error al enviar el correo.'
                    );

                    break;

            }

        }

    }


    _events() {
        createAccountTermsPrivacyPolicyTextForLink.addEventListener("click", () => {
            GENRALHELPERS._openOutboundLink('https://mercadomaiprivacy.netlify.app')
        });
        SingUpWindowButtonClose.addEventListener("click", () => {
            this._close();
        });
        deleteAccountDeleteAllWindowButtonClose.addEventListener("click", () => {
            this._closeDeleteAll();
        });
        SignUpWindowProfileAccountEmailVerifyAlertButtonVerify.addEventListener("click", () => {
            this._openEmailVerification();
        });




        deleteAccountDeleteAllWindowButtonDeleteAll.addEventListener("click", async () => {
            try {
                const completed = await this._deleteAllNow();

                if (completed) {
                    this._closeDeleteAll()
                    this._openDeleteAll()
                }
            } catch (error) {
                alert('Nos encontramos con un error. Sugerimos que cieras la app, e intentas de nuevo. si sigue el problema, contáctanos.')
                // At least one deletion failed.
            }
        });

        deleteAccountDeleteAllWindowButtonDeleteAccount.addEventListener("click", () => { this._deleteAccountNow(); });



        SingUpWindowButtonSelectSignUp.addEventListener("click", () => { this._select("signUp"); });
        SingUpWindowButtonSelectSignIn.addEventListener("click", () => { this._select("signIn"); });


        SignUpWindowButtonSignUp.addEventListener("click", () => { this._signUp(); });
        SignUpWindowButtonConfirmEmailConfirmEmail.addEventListener("click", () => { this._signIn(); });
        SignUpWindowButtonConfirmEmailResendCode.addEventListener("click", () => { this._resendCode(); });
        SignUpWindowButtonConfirmEmailChangeEmail.addEventListener("click", () => { this._changeEmail(); });
        SignUpWindowButtonSignIn.addEventListener("click", () => { this._signIn(); });
        SignUpWindowButtonForgotPassword.addEventListener("click", () => { this._forgotPassword(); });
        SignUpWindowButtonChangePassword.addEventListener("click", () => { this._forgotPassword(); });
        SignUpWindowProfileAccountButtonSignOut.addEventListener("click", () => { this._signOut(); });
        SignUpWindowProfileAccountButtonDeleteAccount.addEventListener("click", () => { this._openDeleteAll() });

        ProfileButtonSaveProfile.addEventListener("click", () => { this._saveSellerProfile(); });


        const profileImageInput = document.getElementById('profileImageInput');
        const ProfileImgContainer = document.getElementById('ProfileImgContainer');

        profileImageInput.addEventListener('change', (event) => {
            const file = event.target.files[0];
            if (!file) return;

            const reader = new FileReader();
            reader.onload = (e) => {
                ProfileImgContainer.src = e.target.result; // sets the image src
                this.#profileImageChanged = true
            };
            reader.readAsDataURL(file);
        });

    }

}


export default new signUpProfile();